import { useEffect, useState } from 'react';

interface ChangelogItem {
    versionNumber: string;
    content: {
        heading: string;
        listItems: { subtitle: string; text: string }[];
    }[];
}

export default function useChangelog() {
    const [changelog, setChangelog] = useState<ChangelogItem[]>([]);

    useEffect(() => {
        // Fetch the changelog file when the component mounts
        fetch('/CHANGELOG.md')
            .then((response) => response.text())
            .then((changelogText) => {
                const versions = changelogText
                    .split('## Changelog version')
                    .filter(Boolean);

                // Parse each version
                const parsedVersions = versions.map((version) => {
                    const lines = version.split('\n');

                    // Extract version number
                    const versionNumber = lines[0].trim();
                    // Extract content excluding the version number
                    const content: {
                        heading: string;
                        listItems: { subtitle: string; text: string }[];
                    }[] = [];
                    let currentHeading = '';
                    let listItems: { subtitle: string; text: string }[] = [];

                    lines.slice(1).forEach((line) => {
                        if (line.startsWith('###')) {
                            // If a new heading is encountered, push the current listItems with heading
                            if (listItems.length > 0) {
                                content.push({
                                    heading: currentHeading,
                                    listItems: listItems,
                                });
                                listItems = [];
                            }
                            currentHeading = line.replace('###', '').trim();
                        } else if (line.startsWith('- **')) {
                            const subtitle = line
                                .replace('- **', '')
                                .split(':')[0]
                                .trim();
                            const text = line
                                .replace('- **', '')
                                .split(':')[1]
                                .replace('**', '')
                                .trim(); // Remove ** from text
                            listItems.push({ subtitle, text });
                        } else {
                            const subtitle = '';
                            const text = line;
                            listItems.push({ subtitle, text });
                        }
                    });

                    // Push the remaining listItems
                    if (listItems.length > 0) {
                        content.push({
                            heading: currentHeading,
                            listItems: listItems,
                        });
                    }

                    return {
                        versionNumber: versionNumber,
                        content: content,
                    };
                });
                parsedVersions.shift();
                setChangelog(parsedVersions);
            })
            .catch((error) =>
                console.error('Error fetching changelog:', error),
            );
    }, []);

    return changelog;
}
